import { ItemsContainer } from "../../Containers/ItemsContainer/ItemsContainer";
import { PreviewContentContainer } from "../../Containers/PreviewContentContainer/PreviewContentContainer";
import { Icons } from "./Icons/Icons";
import { PaddingBottom } from "./Padding/PaddingBottom/PaddingBottom";
import { PaddingTop } from "./Padding/PaddingTop/PaddingTop";
import { TextBoxes } from "./TextBoxes/TextBoxes";
import { usePreviewContent } from "./usePreviewContent";

export const PreviewContent = () => {
    const obj = usePreviewContent();
    if (!obj) return null;
    const { calculatedSettings, shadowItemsContainerRef, template, xRatio, yRatio } = obj;
    return (
        <PreviewContentContainer
            itemsContainerSettings={calculatedSettings.itemsContainer}
            itemsContainerRef={shadowItemsContainerRef}
        >
            <PaddingTop xRatio={xRatio} yRatio={yRatio} />
            <ItemsContainer settings={calculatedSettings} template={template}>
                <TextBoxes xRatio={xRatio} yRatio={yRatio} />
                <Icons xRatio={xRatio} yRatio={yRatio} />
            </ItemsContainer>
            <PaddingBottom xRatio={xRatio} yRatio={yRatio} />
        </PreviewContentContainer>
    );
};
